module.exports = __webpack_public_path__ + "img/logo_jaegermeister.70665801.png";